import { FC, useContext, useMemo } from 'react'

import { Tooltip as ChakraTooltip, IconButton } from '@chakra-ui/react'
import { EditorContext } from '@editor/contexts/Editor'
import { Tooltip } from '@infraloop/common'

const SubToolbarButton: FC<{
  icon: React.ReactElement
  label: string
  toolType: string
  tooltipPlacement?: Required<ChakraTooltip.RootProps>['positioning']['placement']
  size?: 'sm' | 'md' | 'lg'
  selected?: boolean
  disabled?: boolean
  onClick?: () => void
}> = ({
  icon,
  label,
  toolType,
  tooltipPlacement = 'bottom',
  size = 'md',
  selected = false,
  disabled = false,
  onClick,
}) => {
  // Context
  const { selectedSubTool, changeSubTool } = useContext(EditorContext)

  // Derived
  const isSelected = useMemo(() => {
    // If selected is defined, use it without falling back to selectedSubTool check
    if (selected !== undefined) {
      return selected
    }

    return selectedSubTool === toolType
  }, [selectedSubTool, toolType, selected])

  return (
    /* TODO: style migration needed - p=2 */
    /* TODO: style migration needed - fontSize=xs */
    /* TODO: style migration needed - fontWeight=normal */
    <Tooltip showArrow positioning={{ placement: tooltipPlacement }} label={label}>
      <IconButton
        variant="editorGhost"
        aria-label={label}
        position="relative"
        disabled={disabled}
        bgColor={isSelected && !disabled ? 'gray2.600' : undefined}
        color={isSelected && !disabled ? 'white' : 'whiteAlpha.800'}
        _disabled={{
          color: 'whiteAlpha.400',
        }}
        size={size}
        onClick={
          disabled
            ? undefined
            : onClick ||
              (() => {
                changeSubTool(toolType)
              })
        }
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}

export default SubToolbarButton
